<template>
  <section class="slider__area p-relative">
    <div class="slider__wrapper swiper-container">
      <swiper ref="mySwiper" :modules="modules" :effect="'fade'" :loop="true" :autoplay="{ delay: 5000 }">
        <swiper-slide v-for="(vm,index) in carousel" :key="index">
          <div class="single-slider swiper-slide slider__height slider__overlay d-flex align-items-end"
            :style="{ background: 'url(' + baseUrl + vm.image + ')', backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }">
            <div class="container pb-150">
              <div class="row">
                <div class="col-md-9 col-sm-10 col-12">
                  <div class="slider__content">
                    <h5 class="slider__title" style="font-size: clamp(24px, 4vw, 40px);">{{ vm?.title_uz }}</h5>
                    <br>
                    <button @click="openLink(vm?.link)" type="submit" class="e-btn e-btn-3" style="position:absolute; z-index: 3; border-radius:50px; cursor: pointer !important; background-color: #fff; color: #0e1133">{{ $t('actions.detail') }}  <i class="fad fa-arrow-right" style="font-size: 14px;"></i></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation, EffectFade, Autoplay } from "swiper";
import { mapGetters, mapActions } from 'vuex'
import BlogMixin from '../../mixins/blogMixin';

export default {
  name: "HeroSlider",
  mixins:[BlogMixin],
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      sliderData: [
        {
          id: 1,
          img: require(`@/assets/img/slider/slider-4.jpg`),
          title:
            'Find the right Online <span class="yellow-bg">tutor <img src="img/shape/yellow-bg.png" alt=""> </span> for you.',
        },
        {
          id: 2,
          img: require(`@/assets/img/slider/slider-1.jpg`),
          title:
            'Fundamentals of music <span class="yellow-bg">theory <img src="../../assets/img/shape/yellow-bg.png" alt=""> </span> Learn',
        },
        {
          id: 3,
          img: require(`@/assets/img/slider/slider-2.jpg`),
          title:
            'Become a product  <span class="yellow-bg">Manager <img src="../../assets/img/shape/yellow-bg.png" alt=""> </span> & learn.',
        },
        {
          id: 4,
          img: require(`@/assets/img/slider/slider-3.jpg`),
          title:
            'Launch your <span class="yellow-bg">online <img src="../../assets/img/shape/yellow-bg.png" alt=""> </span> learning Platform.',
        },
      ],
      sliderNavData: [
        {
          id: 1,
          img: require(`@/assets/img/slider/nav/slider-nav-4.jpg`),
          title: "6 Courses",
          subtitle: "Programming Languages",
          bgColor: "orange-bg",
        },
        {
          id: 2,
          img: require(`@/assets/img/slider/nav/slider-nav-1.jpg`),
          title: "4 Courses",
          subtitle: "Idea Discussion",
          bgColor: "blue-bg",
        },
        {
          id: 3,
          img: require(`@/assets/img/slider/nav/slider-nav-2.jpg`),
          title: "8 Courses",
          subtitle: "Web Development",
          bgColor: "pink-bg",
        },
        {
          id: 4,
          img: require(`@/assets/img/slider/nav/slider-nav-3.jpg`),
          title: "9 Courses",
          subtitle: "System Administration",
          bgColor: "green-bg",
        },
      ],
    };
  },
  setup() {
    return {
      modules: [Navigation, EffectFade, Autoplay],
    };
  },
  computed: {
    ...mapGetters('carousel', ['carousel'])
  },
  created() {
    this.getCarousel()
  },
  methods: {
    ...mapActions('carousel', ['getCarousel']),
    openLink(url) {
    if (url) { window.open(url, '_blank') }
  }
  }
}
</script>
